import { apiRequest } from "./api";

export type AdjustmentType = "DEDUCTION" | "ADDITION";
export type AdjustmentStatus = "PENDING" | "APPLIED" | "CANCELLED";

export interface PayslipAdjustment {
  adjId: string;
  userId: string;
  businessId: string;
  targetPeriod: string;
  type: AdjustmentType;
  label: string;
  amount: number;
  status: AdjustmentStatus;
  reason?: string;
  sourceDate?: string;
  employeeName?: string;
  createdBy: string;
  appliedAt?: string;
  cancelledAt?: string;
  cancelledBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAdjustmentPayload {
  userId: string;
  targetPeriod: string;
  type: AdjustmentType;
  label: string;
  amount: number;
  reason?: string;
  sourceDate?: string;
}

export const adjustmentApi = {
  list: (businessId: string, targetPeriod: string) =>
    apiRequest<{ items: PayslipAdjustment[] }>(
      `/biz/${encodeURIComponent(businessId)}/adjustments`,
      { params: { targetPeriod } },
    ),

  create: (businessId: string, payload: CreateAdjustmentPayload) =>
    apiRequest<PayslipAdjustment>(
      `/biz/${encodeURIComponent(businessId)}/adjustments`,
      { method: "POST", body: payload },
    ),

  cancel: (businessId: string, adjId: string, userId: string) =>
    apiRequest<{ success: boolean }>(
      `/biz/${encodeURIComponent(businessId)}/adjustments/${encodeURIComponent(adjId)}/cancel`,
      { method: "PATCH", body: { userId } },
    ),
};
